import React from 'react';

export const HilalIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.44602 15.5533H15.5521V8.44979H8.44602V15.5533ZM3 12.0021C3 7.03231 7.02772 3 12.0002 3C16.9716 3 21 7.03231 21 12.0021C21 16.9716 16.9716 21 12.0002 21C7.02772 21 3 16.9716 3 12.0021ZM4.63465 12.0021C4.63465 16.0684 7.93159 19.3642 12.0002 19.3642C16.0682 19.3642 19.3664 16.0684 19.3664 12.0021C19.3664 7.93371 16.0682 4.63583 12.0002 4.63583C7.93159 4.63583 4.63465 7.93371 4.63465 12.0021Z"
        fill="#F28131"
      />
    </svg>
  );
};
